import { E1, E2, E3 } from './constants';

export const getEnvironment = ({
  localeFilename,
}) => {
  switch (localeFilename) {
    case 'integration':
      return E1;
    case 'qa':
      return E2;
    default:
      return E3;
  }
};
